// extracted by mini-css-extract-plugin
export default {"thumbnail":"media_thumbnail__muoUS","folder":"media_folder__35VYT","preview":"media_preview__qFMkx","detail":"media_detail__H1RV+"};